import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../shared.service';
import { AppService } from '../../app.service';


@Component({
  selector: 'ba-initial',
  templateUrl: './initial.component.html',
  styleUrls: ['./initial.component.css']
})
export class InitialComponent implements OnInit {
  updateSideNav: boolean;
  isSwitchUser: any = false;
  switchUserData: any;
  switchUserSubscribe: any;
  pageScrollingEnabled: boolean = true;
  constructor(public sharedService: SharedService,
              private cdRef:ChangeDetectorRef,
              public appService: AppService) {
    this.switchUserSubscribe = this.appService.switchUser$.subscribe((data) => {
      this.isSwitchUser = data;
    });
    // const selectedLanguage = localStorage.getItem('selectedLanguage');
    // this.translate.setDefaultLang('en');
    // if (selectedLanguage) {
    //   this.translate.use(selectedLanguage);
    // } else {
    //   this.translate.use('en');
    // }
  }

  ngOnInit() {
   this.isSwitchUser = false;
   this.appService.pageScrollingSubject$.subscribe((data) => {
     this.pageScrollingEnabled = data;
   });
  }

  ngAfterViewChecked()
{
  let user: any = JSON.parse(localStorage.getItem("loggedInUser"));
    if(user && user.isSwitchBackVisible){
      this.isSwitchUser = true;
    }
  this.cdRef.detectChanges();
}



  getUpdatedSideBarState(event): void {
    this.updateSideNav = event;
  }

  ngOnDestroy(){
   if(this.switchUserSubscribe){
     this.switchUserSubscribe.unsubscribe();
   }
  }

}
